import React from 'react'
import { Control, Controller, UseFormSetValue } from 'react-hook-form'
import { InferType } from 'yup'
import { DropdownSelect } from '../../common/DropdownSelect'
import { societyCreatePostSchema } from '../../../forms/schemas/society_create_post'
import { DropdownItemContent } from '../DropdownItemContent'
import { SocietyAvatarWithMediaId } from '../../common/Avatar'
import { FormControl } from '../../common/FormControl'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { useIsMobile } from '../../../hooks/useIsMobile'
import { ISocietiesModel } from '../../../interfaces/models/societies.interfaces'
import { i18nSocietyType } from '../../../i18n'

interface SocietyDropdownProps {
  setValue: UseFormSetValue<InferType<typeof societyCreatePostSchema>>
  control: Control<InferType<typeof societyCreatePostSchema>>
  societies: ISocietiesModel[]
}

export const SocietyDropdown = ({
  setValue,
  control,
  societies,
}: SocietyDropdownProps): JSX.Element => {
  const { translate } = useAppTranslation()
  const isMobile = useIsMobile()

  const onCustomChange = (): void => {
    setValue('role', 'resident')
    setValue('groupsIds', [])
  }

  const dropdownOptions = societies.map((society) => ({
    value: society._id,
    label: society.name,
    image: (
      <SocietyAvatarWithMediaId size={30} mediaId={society?.coverPhotoId} />
    ),
  }))

  const shouldRender = societies.length > 1

  return (
    <>
      {shouldRender && (
        <Controller
          control={control}
          name="society"
          render={({ field: { name, value, onChange } }) => (
            <FormControl
              name={name}
              label={translate('common.form.labels.society', {
                context: i18nSocietyType(
                  societies.find((_society) => _society._id === value)
                    ?.societyTypeDisplayName
                ),
              })}
            >
              <DropdownSelect
                value={value}
                onChange={(val: unknown) => {
                  onChange(val)
                  onCustomChange()
                }}
                options={dropdownOptions}
                dropdownWidth={isMobile ? 'w-full' : 'w-60'}
                {...(!isMobile && {
                  dropdownContentWidth: 'w-fit',
                  dropdownPosition: 'bottom-right',
                })}
                renderItemContent={(option) => (
                  <DropdownItemContent option={option} />
                )}
              />
            </FormControl>
          )}
        />
      )}
    </>
  )
}
